// extracted by mini-css-extract-plugin
export default {"form_ct":"ClassModi_form_ct__l94tq","select_input":"ClassModi_select_input__3dXGD","input_group":"ClassModi_input_group__pV5oo","modi_btn":"ClassModi_modi_btn__WXrcN"};